import React from 'react';
import { Polygon } from '@react-google-maps/api';

import type { TenantRoute } from '@types';
import { routeColor } from '@utils/tenantRoutes';

/** `color` defaults to the route's position in the list */
export type ColoredRoute = TenantRoute & { color?: string };

type PropsType = {
    routes: ColoredRoute[],
    /** Drawn heavier and on top */
    highlightedId?: number | null,
    /** Fill/stroke of routes that are not highlighted (default: faint background routes) */
    fillOpacity?: number,
    strokeWeight?: number
};

/** Routes as non-editable, non-clickable polygons coloured with routeColor. */
export default function RoutePolygons(props: PropsType) {
    const {
        routes, highlightedId, fillOpacity = 0.12, strokeWeight = 1.5
    } = props;
    return (
        <>
            {routes.map((route, index) => {
                const color = route.color ?? routeColor(index);
                const highlighted = route.id === highlightedId;
                return (
                    <Polygon
                        key={route.id}
                        paths={route.points}
                        options={{
                            strokeColor: color,
                            fillColor: color,
                            fillOpacity: highlighted ? 0.28 : fillOpacity,
                            strokeWeight: highlighted ? 2.5 : strokeWeight,
                            strokeOpacity: 1,
                            clickable: false,
                            editable: false,
                            draggable: false,
                            zIndex: highlighted ? 2 : 1
                        }}
                    />
                );
            })}
        </>
    );
}
